import { Button, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { getRoute } from '@hotjar/webapp/utils/routing';
import { BASE as PlaybackBase } from '@hotjar/webapp/constants/routes/playbacks';
import { LIST_CONTINUOUS_CAPTURE as HeatmapsCC } from '@hotjar/webapp/constants/routes/heatmaps';
import noHighlightsOnTheListImg from '@hotjar/webapp/images/highlights/noHighlightsOnTheList.png';

type EmptyStateProps = {
  siteId: string;
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${tokens.spacer.x8};
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 340px;
  margin-top: ${tokens.spacer.x8};
`;

const Title = styled.h5`
  ${tokens.text('header5')}
  margin: ${tokens.spacer.x3} 0 0;
`;

const Copy = styled.p`
  ${tokens.text('body1')}
  margin: ${tokens.spacer.x1} 0 ${tokens.spacer.x3};
  text-align: center;
`;

const ButtonWithMargin = styled(Button)`
  margin-bottom: ${tokens.spacer.x2};
`;

export const HighlightsEmptyState = ({ siteId }: EmptyStateProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <Section>
        <img src={noHighlightsOnTheListImg} alt={t('highlights:emptyState.img-alt')} />
        <Title>{t('highlights:emptyState.title')}</Title>
        <Copy>{t('highlights:emptyState.copy')}</Copy>
        <ButtonWithMargin
          as="a"
          href={getRoute(PlaybackBase.path, { siteId })}
          icon="recordings_old"
        >
          {t('highlights:emptyState.button-label-recordings')}
        </ButtonWithMargin>
        <Button
          as="a"
          href={getRoute(HeatmapsCC.path, { siteId })}
          kind="secondary"
          icon="heatmaps"
        >
          {t('highlights:emptyState.button-label-heatmaps')}
        </Button>
      </Section>
    </Container>
  );
};
